import styled, { keyframes } from "styled-components";

import React from 'react'
import { useSelector } from "react-redux";

function BackgroundEffect() {
  const path = useSelector(state=> state.bgEffect.bgPath)

  return (
    <Gradient path={path}/>
  )
}

export default BackgroundEffect




const rotate = keyframes`
  0% {
    transform: translateX(0) rotate(0deg); /* Initial position and rotation */
  }
  25% {
    transform: translateX(100px) rotate(90deg); /* Move 50px to the right and rotate a quarter */
  }
  50% {
    transform: translateX(200px) rotate(180deg); /* Move 100px to the right and rotate halfway */
  }
  75% {
    transform: translateX(100px) rotate(270deg); /* Move 50px to the left and rotate three quarters */
  }
  100% {
    transform: translateX(0) rotate(360deg); /* Back to the initial position with full rotation */
  }
`;

const bgChange = keyframes`
  0% {
    opacity: 0;
  }

  0% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
`;


export const Gradient = styled.div`
  --size: 250px;
  --speed: 10s;
  --easing: cubic-bezier(0.8, 0.2, 0.2, 0.8);

    opacity: 0.4;
     position: absolute;

     top: 27%;
     left: 37%;

  width: var(--size);
  height: var(--size);
  filter: blur(calc(var(--size) / 5));
  background-image: ${props=>
  props.path === 'res'? 'linear-gradient(var(--res-color), cyan)':
  props.path === 'se'?  'linear-gradient(var(--se-color), brown)':
  props.path === 'tst'?  'linear-gradient(var(--tst-color), #7fffd4)':
  props.path === 'cntnt'?  'linear-gradient(var(--cntnt-color), red)':
  props.path === 'bl'?  'linear-gradient(var(--bl-color), green)':
  props.path === 'feedback'?  'linear-gradient(white, dodgerblue)':
  props.path === 'support'?  'linear-gradient(white, lightsalmon)':
  ''
  };  
  animation: ${rotate} var(--speed) var(--easing) alternate infinite, ${bgChange} 2s ease-in-out;
  border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;

  @media (min-width: 720px) {
    --size: 500px;
  }
`;



// const moveBackground = keyframes`
//   0% {
//     background-position: 0 0;
//   }

//   50% {
//     background-position: 50px 50px;
//   }

//   75% {
//     background-position: -35px 35px;
//   }

//   100% {
//     background-position: 0 -100px; /* Adjust the value to control the speed and direction of the animation */
//   }
// `;

// const BackgroundAnimation = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   z-index: -1;
//   background-image: 
//     linear-gradient(to right, #86e5ff6c 1px, #010132 1px),
//     linear-gradient(to bottom, #86e5ff6c 1px, #010132 1px);
//   background-size: 50px 50px; /* Adjust the size of squares */
//   animation: ${moveBackground} 190s linear infinite;
// `;